<script>
import { Bar } from 'vue-chartjs';

export default {
  name: 'Data-Bar',
  extends: Bar,
  props: {
    chartData: {
      required: true,
    },
    chartTitle: {

    },
  },
  mounted() {
    this.render();
  },
  methods: {
    render() {
      const options = {
        legend: {
          display: true,
          labels: {
            fontSize: 14,
            boxWidth: 14,
          },
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [{
            stacked: true,
            categoryPercentage: 0.5,
            barPercentage: 1,
            ticks: {
              fontSize: 13,
            },
          }],
          yAxes: [{
            stacked: true,
            ticks: {
              fontSize: 13,
            },
          }],
        },
      };

      if (this.chartTitle) {
        options.title = {
          display: true,
          text: this.chartTitle,
        };
      }

      this.renderChart(this.chartData, options);
    },
  },
  watch: {
    chartData: function() {
      this.render();
    },
  },
};
</script>
